import { useEffect, useRef } from 'react'

const PIXEL_ID = '846969475009809'

declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
  }
}

export function useMetaPixel() {
  const initialized = useRef(false)

  useEffect(() => {
    if (initialized.current) return
    initialized.current = true

    // Prevent duplicate pixel initialization
    if (window.fbq) {
      window.fbq('track', 'PageView')
      window.fbq('track', 'Purchase', {
        value: 9.99,
        currency: 'USD',
        content_name: 'Compra Hotmart',
      })
      return
    }

    // Facebook Pixel base code
    const f = window
    const b = document
    const n = function (...args: unknown[]) {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args)
    } as typeof window.fbq & {
      callMethod?: (...args: unknown[]) => void
      queue: unknown[][]
      loaded: boolean
      version: string
      push: (...args: unknown[]) => void
    }

    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []

    f.fbq = n
    f._fbq = n

    // Load the FB pixel script
    const script = b.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    const firstScript = b.getElementsByTagName('script')[0]
    if (firstScript?.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript)
    } else {
      b.head.appendChild(script)
    }

    // Initialize pixel and fire events
    window.fbq('init', PIXEL_ID)
    window.fbq('track', 'PageView')
    window.fbq('track', 'Purchase', {
      value: 9.99,
      currency: 'USD',
      content_name: 'Compra Hotmart',
    })

    // Add noscript fallback image
    const noscript = b.createElement('img')
    noscript.height = 1
    noscript.width = 1
    noscript.style.display = 'none'
    noscript.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
    b.body.appendChild(noscript)
  }, [])
}
